(() => {

  // ANFANG: Variable für Kundennummer-Tracking 18.05.25
  let kundennummerCartAttributeSent = false;
  // ENDE: Variable für Kundennummer-Tracking 18.05.25
  
  const initCartAttributesHandlers = () => {
    const cartNote = document.querySelector(".cart__widget textarea#note");
    const cartGiftNote = document.querySelector(
      ".cart__widget textarea#gift-note"
    );

    console.log("first", cartNote, cartGiftNote);
    if (cartNote) {
      console.log(cartNote);
      cartNote.addEventListener("change", (e) => {
        console.log("asd");
        updateCartAttributes("note", e.target.value);
      });
    }

    if (cartGiftNote) {
      cartGiftNote.addEventListener("change", (e) => {
        updateCartAttributes("gift_note", e.target.value);
      });
    }

    // ANFANG: Optimierter Code für Kundennummer 18.05.25
    if (!kundennummerCartAttributeSent) { // Prüfe das neue Flag
      const kundennummerInput = document.querySelector(
        'input[type="hidden"][name="attributes[Kundennummer]"]'
      );

      if (kundennummerInput) {
        const kundennummerValue = kundennummerInput.value;

        if (kundennummerValue && kundennummerValue.trim() !== "") {
          // Rufe updateCartAttributes auf und handle das Ergebnis
          fetch("/cart/update.js", { // Wir verwenden fetch direkt hier, um das Flag zu setzen
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              attributes: {
                "Kundennummer": kundennummerValue,
              },
            }),
          })
          .then(response => {
            if (response.ok) {
              // console.log("Cart-Attribut 'Kundennummer' erfolgreich gesetzt.");
              kundennummerCartAttributeSent = true; // Wichtig: Flag erst bei Erfolg setzen!
            } else {
              // Für dich zum Debuggen, nicht für den Händler sichtbar in der Konsole, es sei denn, DevTools sind offen.
              console.error(
                "Fehler beim Setzen des Cart-Attributs 'Kundennummer'. Status:",
                response.status
              );
            }
            return response.json(); // Optional: Antwort weiterverarbeiten
          })
          .catch(error => {
            // Für dich zum Debuggen
            console.error(
              "Netzwerkfehler beim Setzen des Cart-Attributs 'Kundennummer':",
              error
            );
          });
        }
      }
    }
    // ENDE: Optimierter Code für Kundennummer 18.05.25
    
  };

  const updateCartAttributes = (key, value) => {
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        attributes: {
          [key]: value,
        },
      }),
    });
  };

  document.addEventListener("theme:cart:open", initCartAttributesHandlers);
  document.addEventListener("DOMContentLoaded", initCartAttributesHandlers);
})();
